var map = {
	"./action_img.png": 86,
	"./background.png": 231,
	"./banner_shap.png": 232,
	"./bulb.png": 233,
	"./cloud-computing.png": 234,
	"./cloud.png": 235,
	"./cloud_01.png": 87,
	"./cloud_02.png": 88,
	"./cloud_03.png": 89,
	"./cloud_04.png": 90,
	"./cloud_05.png": 91,
	"./cloud_06.png": 92,
	"./cloud_blue.png": 236,
	"./crm_img1.jpg": 237,
	"./crm_img2.jpg": 238,
	"./crm_img3.jpg": 239,
	"./erp_dashboard.jpg": 93,
	"./erp_icon1.png": 240,
	"./erp_icon2.png": 241,
	"./erp_icon3.png": 242,
	"./erp_icon4.png": 243,
	"./erp_icon5.png": 244,
	"./erp_icon6.png": 245,
	"./growth.png": 246,
	"./img/01.png": 94,
	"./img/02.png": 95,
	"./img/03.png": 96,
	"./img/04.png": 97,
	"./img/05.png": 98,
	"./img/06.png": 99,
	"./img/07.png": 100,
	"./img/08.png": 101,
	"./img/09.png": 102,
	"./img/10.png": 103,
	"./img/11.png": 104,
	"./img/12.png": 105,
	"./img/13.png": 106,
	"./img/14.png": 107,
	"./img/15.png": 108,
	"./img/16.png": 109,
	"./img/17.png": 110,
	"./img/18.png": 111,
	"./img/19.png": 112,
	"./img/20.png": 113,
	"./quote.png": 247,
	"./rocket.png": 114,
	"./settings.png": 248,
	"./settings1.png": 249,
	"./shape.png": 250,
	"./software_development.png": 251,
	"./team.png": 252,
	"./testimonial_img.jpg": 253,
	"./testimonial_img2.jpg": 254,
	"./website.png": 255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;